import React, { useContext } from "react";
import aEvent from "../../common/aEvent";
import decorateUrl from "../../common/decorateUrl";
import { UtmContext } from "../../contexts/UtmContext";
import linkedinEvent from "../../lib/linkedin-event";
import ApplyNowTooltip from "../ApplyNowTooltip";
import { Typo16 } from "../Typography";
import { ApplyNowText, ApplyNowWrapper, ApplyTooltipTrigger } from "./styles";

interface Props {
  applyUrl: string;
  slug: string;
  hideInfo?: boolean;
}

const JobListItemApplyNow: React.FC<Props> = (props) => {
  const { applyUrl, hideInfo, slug } = props;

  const { utms } = useContext(UtmContext);

  const decoratedUrl = decorateUrl(applyUrl, utms);

  return (
    <ApplyNowWrapper>
      <ApplyNowText 
        href={decoratedUrl || "google.com"} 
        target="_blank"
        onClick={() => { 
          linkedinEvent('toggl');
        }}
      >
        <Typo16
          color="#658AC8"
          fontWeight="500"
          style={{ pointerEvents: "none" }}
        >
          APPLY NOW
        </Typo16>
      </ApplyNowText>
      {!hideInfo && (
        <ApplyNowTooltip
          lateHoverEvent={() => {
            aEvent({
              ec: "Apply Now Interaction",
              ea: "info-5-second-hover",
              el: slug,
            });
          }}
        >
          <ApplyTooltipTrigger>
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.5 5.875C6.33424 5.875 6.17527 5.94085 6.05806 6.05806C5.94085 6.17527 5.875 6.33424 5.875 6.5V9C5.875 9.16576 5.94085 9.32473 6.05806 9.44194C6.17527 9.55915 6.33424 9.625 6.5 9.625C6.66576 9.625 6.82473 9.55915 6.94194 9.44194C7.05915 9.32473 7.125 9.16576 7.125 9V6.5C7.125 6.33424 7.05915 6.17527 6.94194 6.05806C6.82473 5.94085 6.66576 5.875 6.5 5.875ZM6.7375 3.425C6.58534 3.36249 6.41467 3.36249 6.2625 3.425C6.18578 3.45475 6.11569 3.49935 6.05625 3.55625C6.00105 3.617 5.95665 3.68676 5.925 3.7625C5.89001 3.83667 5.87289 3.91801 5.875 4C5.87453 4.08225 5.89029 4.16379 5.9214 4.23994C5.9525 4.31609 5.99833 4.38535 6.05625 4.44375C6.117 4.49896 6.18676 4.54335 6.2625 4.575C6.35719 4.6139 6.45998 4.62895 6.56184 4.61882C6.66371 4.60869 6.76152 4.5737 6.8467 4.51692C6.93187 4.46014 7.00179 4.3833 7.05032 4.29317C7.09885 4.20304 7.12449 4.10236 7.125 4C7.1227 3.83452 7.05796 3.67602 6.94375 3.55625C6.88431 3.49935 6.81422 3.45475 6.7375 3.425ZM6.5 0.25C5.26387 0.25 4.0555 0.616556 3.02769 1.30331C1.99988 1.99007 1.1988 2.96619 0.725756 4.10823C0.252708 5.25027 0.128937 6.50693 0.370095 7.71931C0.611252 8.9317 1.20651 10.0453 2.08059 10.9194C2.95466 11.7935 4.06831 12.3888 5.28069 12.6299C6.49307 12.8711 7.74974 12.7473 8.89178 12.2742C10.0338 11.8012 11.0099 11.0001 11.6967 9.97231C12.3834 8.94451 12.75 7.73613 12.75 6.5C12.75 5.67924 12.5883 4.86651 12.2743 4.10823C11.9602 3.34994 11.4998 2.66095 10.9194 2.08058C10.3391 1.50022 9.65006 1.03984 8.89178 0.725753C8.13349 0.411661 7.32076 0.25 6.5 0.25ZM6.5 11.5C5.5111 11.5 4.5444 11.2068 3.72215 10.6573C2.89991 10.1079 2.25904 9.32705 1.88061 8.41342C1.50217 7.49979 1.40315 6.49445 1.59608 5.52455C1.789 4.55464 2.26521 3.66373 2.96447 2.96447C3.66373 2.2652 4.55465 1.789 5.52455 1.59607C6.49446 1.40315 7.49979 1.50216 8.41342 1.8806C9.32705 2.25904 10.1079 2.8999 10.6574 3.72215C11.2068 4.54439 11.5 5.51109 11.5 6.5C11.5 7.82608 10.9732 9.09785 10.0355 10.0355C9.09786 10.9732 7.82609 11.5 6.5 11.5Z"
                fill="#658AC8"
              />
            </svg>
          </ApplyTooltipTrigger>
        </ApplyNowTooltip>
      )}
    </ApplyNowWrapper>
  );
};

export default JobListItemApplyNow;
